import * as moment from "moment";
import { storage, database } from "../firebase";

export const fetchAllPersonClients = async (info) => {
  try {
    const clientList = [];
    const allClients = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("clients")
      .where("type", "==", "person")
      .get();
    if (allClients.size > 0) {
      allClients.forEach((client) => {
        const single = fetchPersonClient(client.id, client.data());
        clientList.push(single);
      });
    }
    return Promise.all(clientList).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchPersonClient = (clientId, client) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(client.addedBy)
      .get()
      .then((user) => {
        if (user.exists) {
          resolve({
            id: clientId,
            general: {
              firstName:
                client.general && client.general.firstName
                  ? client.general.firstName
                  : null,
              lastName:
                client.general && client.general.lastName
                  ? client.general.lastName
                  : null,
            },
            contact: {
              email:
                client.contact && client.contact.email
                  ? client.contact.email
                  : null,
              phone:
                client.contact && client.contact.phone
                  ? client.contact.phone
                  : null,
              website:
                client.contact && client.contact.website
                  ? client.contact.website
                  : null,
            },
            social: {
              facebook:
                client.social && client.social.facebook
                  ? client.social.facebook
                  : null,
              twitter:
                client.social && client.social.twitter
                  ? client.social.twitter
                  : null,
            },
            address: {
              street:
                client.address && client.address.street
                  ? client.address.street
                  : null,
              postalCode:
                client.address && client.address.postalCode
                  ? client.address.postalCode
                  : null,
              city:
                client.address && client.address.city
                  ? client.address.city
                  : null,
            },
            type: client.type ? client.type : null,
            timestamp: client.timestamp,
            addedBy: `${user.data().firstName} ${user.data().lastName}`,
          });
        } else {
          reject("error");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const fetchAllCompanyClients = async (info) => {
  try {
    const clientList = [];
    const allClients = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("clients")
      .where("type", "==", "company")
      .get();
    if (allClients.size > 0) {
      allClients.forEach((client) => {
        const single = fetchCompanyClient(client.id, client.data());
        clientList.push(single);
      });
    }
    return Promise.all(clientList).then((result) => {
      return { payload: result, error: null };
    });
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchCompanyClient = (clientId, client) => {
  return new Promise((resolve, reject) => {
    database
      .collection("users")
      .doc(client.addedBy)
      .get()
      .then((user) => {
        if (user.exists) {
          resolve({
            id: clientId,
            general: {
              name:
                client.general && client.general.name
                  ? client.general.name
                  : null,
              industry:
                client.general && client.general.industry
                  ? client.general.industry
                  : null,
            },
            contact: {
              email:
                client.contact && client.contact.email
                  ? client.contact.email
                  : null,
              phone:
                client.contact && client.contact.phone
                  ? client.contact.phone
                  : null,
              website:
                client.contact && client.contact.website
                  ? client.contact.website
                  : null,
            },
            social: {
              facebook:
                client.social && client.social.facebook
                  ? client.social.facebook
                  : null,
              twitter:
                client.social && client.social.twitter
                  ? client.social.twitter
                  : null,
            },
            address: {
              street:
                client.address && client.address.street
                  ? client.address.street
                  : null,
              postalCode:
                client.address && client.address.postalCode
                  ? client.address.postalCode
                  : null,
              city:
                client.address && client.address.city
                  ? client.address.city
                  : null,
              region:
                client.address && client.address.region
                  ? client.address.region
                  : null,
            },
            type: client.type ? client.type : null,
            timestamp: client.timestamp,
            addedBy: `${user.data().firstName} ${user.data().lastName}`,
          });
        } else {
          reject("error");
        }
      })
      .catch((e) => {
        reject(e);
      });
  });
};

export const updateSingleClient = async (details) => {
  try {
    await database
      .collection("companies")
      .doc(details.companyId)
      .collection("clients")
      .doc(details.clientId)
      .update(details.client);
    return { error: null, payload: details.type };
  } catch (e) {
    throw new Error(e);
  }
};

export const fetchNewCompanyInformation = async (organizationNumber) => {
  const request = await fetch(`/api/1881/details/${organizationNumber}`, {
    method: "GET",
    headers: { "Content-Type": "application/json" },
  });
  const response = await request.json();
  if (response.error === null) {
    return { error: null, payload: response.payload };
  } else {
    return { error: response.error, payload: null };
  }
};

export const uploadClientLogo = async (info) => {
  try {
    var storageRef = storage.ref();
    var uploadRef = storageRef.child(
      `hosting/company/${info.companyId}/clients/${info.client.id}/thumbnail`
    );
    await uploadRef.put(info.activeCompanyLogo);
    const url = await fetchClientLogoDownloadUrl(info);
    return url;
  } catch (e) {
    throw new Error(e);
  }
};

const fetchClientLogoDownloadUrl = async (info) => {
  try {
    var storageRef = storage.ref();
    var downloadRef = storageRef.child(
      `hosting/company/${info.companyId}/clients/${info.client.id}/thumbnail`
    );
    return await downloadRef.getDownloadURL();
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteSingleClient = async (info) => {
  try {
    const user = await database
      .collection("companies")
      .doc(info.companyId)
      .collection("clients")
      .doc(info.key)
      .get();
    if (user.data().logoUrl && user.data().logoUrl !== null) {
      await storage.refFromURL(user.data().logoUrl).delete();
      await database
        .collection("companies")
        .doc(info.companyId)
        .collection("clients")
        .doc(info.key)
        .delete();
      return { error: null };
    } else {
      await database
        .collection("companies")
        .doc(info.companyId)
        .collection("clients")
        .doc(info.key)
        .delete();
      return { error: null, payload: info.type };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const createNewSingleClient = async (details) => {
  try {
    const changedObject = details.details;
    if (details.type === "company") {
      if (
        changedObject &&
        changedObject.general &&
        changedObject.general.employees
      ) {
        changedObject.general.employees = parseInt(
          changedObject.general.employees.toString().replace(/ /g, "")
        );
      }

      if (
        changedObject &&
        changedObject.address &&
        changedObject.address.postalCode
      ) {
        changedObject.address.postalCode = parseInt(
          changedObject.address.postalCode.toString().replace(/ /g, "")
        );
      }

      if (
        changedObject &&
        changedObject.general &&
        changedObject.general.shareCapital
      ) {
        changedObject.general.shareCapital = parseInt(
          changedObject.general.shareCapital.toString().replace(/ /g, "")
        );
      }

      if (
        changedObject &&
        changedObject.general &&
        changedObject.general.organizationNumber
      ) {
        changedObject.general.organizationNumber = parseInt(
          changedObject.general.organizationNumber.toString().replace(/ /g, "")
        );
      }

      if (
        changedObject &&
        changedObject.general &&
        changedObject.general.established
      ) {
        changedObject.general.established = moment(
          changedObject.general.established
        ).unix();
      }

      changedObject.timestamp = moment().unix();

      const customerExists = await checkCustomerExists(
        details.companyId,
        changedObject.general.organizationNumber
      );

      if (customerExists.error === null) {
        await database
          .collection("companies")
          .doc(details.companyId)
          .collection("clients")
          .add(changedObject);
        return { error: null, payload: "company" };
      } else {
        throw new Error("Bruker eksisterer allerede");
      }
    } else {
      changedObject.timestamp = moment().unix();

      await database
        .collection("companies")
        .doc(details.companyId)
        .collection("clients")
        .add(changedObject);
      return { error: null, payload: "person" };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const checkCustomerExists = async (companyId, organizationNumber) => {
  try {
    const customers = await database
      .collection("companies")
      .doc(companyId)
      .collection("clients")
      .where("organizationNumber", "==", organizationNumber)
      .get();
    if (customers.size > 0) {
      throw new Error("Kunden eksisterer allerede");
    } else {
      return { error: null };
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteSingleCompanyLogo = async (info) => {
  try {
    await storage.refFromURL(info.client.logoUrl).delete();
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteMultipleClientsArray = async (details) => {
  try {
    if (details && details.items.length > 0) {
      const deletions = [];
      details.items.forEach((key) => {
        const single = deleteClient({ companyId: details.companyId, key: key });
        deletions.push(single);
      });

      return Promise.all(deletions).then((result) => {
        return { error: null };
      });
    } else {
      throw new Error("Kunne ikke slette kunder.");
    }
  } catch (e) {
    throw new Error(e);
  }
};

export const deleteClient = async (details) => {
  try {
    const clientInfo = await database
      .collection("companies")
      .doc(details.companyId)
      .collection("clients")
      .doc(details.key)
      .get();
    if (clientInfo.data() && clientInfo.data().logoUrl) {
      const url = clientInfo.data().logoUrl;
      await storage.refFromURL(url).delete();
      await database
        .collection("companies")
        .doc(details.companyId)
        .collection("clients")
        .doc(details.key)
        .delete();
      return { error: null };
    } else {
      await database
        .collection("companies")
        .doc(details.companyId)
        .collection("clients")
        .doc(details.key)
        .delete();
      return { error: null };
    }
  } catch (e) {
    throw new Error(e);
  }
};
